var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
/* eslint-disable max-len */
import React from "react";
import BaseSvgIcon from "../Base";
var AddAdmin = function (props) {
    return (React.createElement(BaseSvgIcon, __assign({}, props, { viewBox: "0 0 20 20" }),
        React.createElement("path", { d: "M19 18.5L1 18.5C.723857625 18.5.5 18.7238576.5 19 .5 19.2761424.723857625 19.5 1 19.5L19 19.5C19.2761424 19.5 19.5 19.2761424 19.5 19 19.5 18.7238576 19.2761424 18.5 19 18.5zM.92 17.5L18.92 17.5C19.1939085 17.4946799 19.4146799 17.2739085 19.42 17L19.42 1C19.42.723857625 19.1961424.5 18.92.5L12.92.5C12.6438576.5 12.42.723857625 12.42 1L12.42 5.39 6.92 5.39C6.64385763 5.39 6.42 5.61385763 6.42 5.89L6.42 9.69.92 9.69C.643857625 9.69.42 9.91385763.42 10.19L.42 17C.42 17.2761424.643857625 17.5.92 17.5zM18.41 1.5L18.41 16.5 13.41 16.5 13.41 5.89C13.41 5.89 13.41 5.89 13.41 5.89L13.41 1.5 18.41 1.5zM7.41 6.39L12.41 6.39 12.41 16.5 7.41 16.5 7.41 6.39zM1.41 10.69L6.41 10.69 6.41 16.5 1.41 16.5 1.41 10.69z" })));
};
export default AddAdmin;
